import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { defaultMapper } from './getSortOrder';

export function getSortOrderBySelected<T>(
  columns: ITableColumn<T>[],
  mapper?: (col: ITableColumn<T>) => string | null,
): string {
  return columns
    .filter(item => item.isSelected)
    .map(mapper ?? defaultMapper)
    .filter(Boolean)
    .join(';');
}
